'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require('redux');

var _reduxImmutableStateInvariant = require('redux-immutable-state-invariant');

var _reduxImmutableStateInvariant2 = _interopRequireDefault(_reduxImmutableStateInvariant);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _iamOpenIdConnectImplicitFlow = require('iam-open-id-connect-implicit-flow');

var _reduxAxiosMiddleware = require('redux-axios-middleware');

var _reduxAxiosMiddleware2 = _interopRequireDefault(_reduxAxiosMiddleware);

var _reduxResponsive = require('redux-responsive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-env node, browser */
// This file merely configures the store for hot reloading.
// This boilerplate file is likely to be the same for each project that uses Redux.
// With Redux, the actual stores are in /reducers.
function configureStore(initialState, axiosClients) {
  return (0, _redux.createStore)(window.dkeReactLauncher.rootReducer, initialState, (0, _redux.compose)(_reduxResponsive.responsiveStoreEnhancer, (0, _redux.applyMiddleware)(_iamOpenIdConnectImplicitFlow.authMiddleware, _reduxThunk2.default, (0, _reduxAxiosMiddleware2.default)(axiosClients.apiClient, axiosClients.options), (0, _reduxImmutableStateInvariant2.default)()), window.devToolsExtension ? window.devToolsExtension() : function (f) {
    return f;
  } // add support for Redux dev tools
  ));
}